import axios from 'axios'
import { Message } from 'element-ui'
import store from '../store'
import { getToken } from '@/utils/auth'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 15000 // 请求超时时间
})

function normalizeRequestPath(url) {
  if (!url) {
    return url
  }
  return url.startsWith('/api/') ? url.substring(4) : url
}

// request拦截器
service.interceptors.request.use(config => {
  config.url = normalizeRequestPath(config.url)
  if (store.getters.token) {
    config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
  /**
  * code为非200是抛错 可结合自己业务进行修改
  */
    const res = response.data
    if (res.code !== 200) {
      if (res.code === 401) {
        Message({
          message: res.message || '登录已失效，请重新登录',
          type: 'warning',
          duration: 2 * 1000
        })
        store.dispatch('FedLogOut').then(() => {
          if (window.location.pathname !== '/login') {
            window.location.replace('/#/login')
          }
        })
        return Promise.reject(res.message || 'unauthorized')
      }
      Message({
        message: res.message,
        type: 'error',
        duration: 3 * 1000
      })
      return Promise.reject('error')
    } else {
      return response.data
    }
  },
  error => {
    console.log('err' + error)// for debug
    if (error && error.response && error.response.status === 401) {
      Message({
        message: '登录已失效，请重新登录',
        type: 'warning',
        duration: 2 * 1000
      })
      store.dispatch('FedLogOut').then(() => {
        if (window.location.pathname !== '/login') {
          window.location.replace('/#/login')
        }
      })
      return Promise.reject(error)
    }
    Message({
      message: error.message,
      type: 'error',
      duration: 3 * 1000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js